// ReceiptCertificate.js
import React, { useEffect, forwardRef } from "react";
import PRMTSService from '../app/service/prmtsService';

const PaymentReceipt = forwardRef(({ member, payments, total, onRenderComplete }, ref) => {
  const canvasRef = ref;
  const prmtsService = new PRMTSService();

  useEffect(() => {
    const generateCertificateImage = async () => {
      try {
        const canvas = canvasRef.current;
        if (!canvas) {
          console.error("Canvas não encontrado!");
          return;
        }

        const ctx = canvas.getContext("2d");
        if (!ctx) {
          console.error("Contexto do canvas não encontrado!");
          return;
        }

        const responseDaytime = await prmtsService.getByType("DAYTIME-SESSION");
        const sessionDayTime = responseDaytime.data.description;

        // Tamanho A4
        const canvasWidth = 595;
        const canvasHeight = 842;
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;

        // Fundo branco
        ctx.fillStyle = "#FFFFFF";
        ctx.fillRect(0, 0, canvasWidth, canvasHeight);

        // Marca d’água
        const watermark = new Image();
        watermark.src = `${process.env.PUBLIC_URL}/assets/marca_dagua_1_normal.png`;

        await new Promise((resolve, reject) => {
          watermark.onload = () => resolve();
          watermark.onerror = () => reject(new Error("Erro ao carregar a marca d'água."));
        });

        const watermarkScale = 0.9;
        const watermarkWidth = canvasWidth * watermarkScale;
        const watermarkHeight = (watermark.height * watermarkWidth) / watermark.width;
        const xPositionWatermark = (canvasWidth - watermarkWidth) / 2;
        const yPositionWatermark = (canvasHeight - watermarkHeight) / 2;

        ctx.globalAlpha = 0.2;
        ctx.drawImage(watermark, xPositionWatermark, yPositionWatermark, watermarkWidth, watermarkHeight);
        ctx.globalAlpha = 1.0;

        // ================================
        // 🔹 Cabeçalho Loja (título/subtítulo)
        // ================================
        ctx.fillStyle = "#000000";
        ctx.textAlign = "center";

        ctx.font = '40px "GreatVibes"';
        ctx.fillText("Loja Maçônica", canvasWidth / 2, 80);
        ctx.fillText("Professor Hermínio Blackman", canvasWidth / 2, 130);
        ctx.fillText("nº 1761", canvasWidth / 2, 180);

        ctx.font = '20px "Times New Roman"';
        ctx.fillText("FEDERADA AO GOB e JURISDICIONADA AO GOB-ES", canvasWidth / 2, 210);
        ctx.fillText(`R.E.A.A. - Reuniões às ${sessionDayTime}`, canvasWidth / 2, 230);
        ctx.fillText("Rua Presidente Lima, 1010, Centro, Vila Velha/ES", canvasWidth / 2, 250);
        ctx.fillText("CEP 29.100-330", canvasWidth / 2, 270);

        // ================================
        // 🔹 Cabeçalho do recibo
        // ================================
        ctx.font = "24px Times New Roman";
        ctx.fillText(`RECIBO DE PAGAMENTO - nº ${payments[0].receipt}`, canvasWidth / 2, 325);

        // Dados do membro
        ctx.textAlign = "left";
        ctx.font = "16px Times New Roman";
        ctx.fillText(`Irmão: ${member.name}`, 50, 365);
        ctx.fillText(`Data do Pagamento: ${new Date().toLocaleDateString("pt-BR")}`, 50, 385);

        // ================================
        // 🔹 Tabela de pagamentos
        // ================================
        const startX = 50;
        let startY = 420;
        const tableWidth = canvasWidth - 100;
        const rowHeight = 30;

        ctx.font = "bold 14px Times New Roman";
        ctx.fillText("Descrição", startX + 5, startY);
        ctx.fillText("Valor (R$)", startX + tableWidth - 100, startY);

        // Linha separadora
        ctx.beginPath();
        ctx.moveTo(startX, startY + 10);
        ctx.lineTo(startX + tableWidth, startY + 10);
        ctx.stroke();

        startY += rowHeight;

        // Linhas com os pagamentos
        ctx.font = "14px Times New Roman";
        payments.forEach((p, idx) => {
          ctx.fillText(`${idx + 1}. ${p.description}`, startX + 5, startY);
          ctx.fillText(`${formatCurrency(p.amount)}`, startX + tableWidth - 100, startY);
          startY += rowHeight;
        });

        // Footer com total
        ctx.beginPath();
        ctx.moveTo(startX, startY + 5);
        ctx.lineTo(startX + tableWidth, startY + 5);
        ctx.stroke();

        ctx.font = "bold 14px Times New Roman";
        ctx.fillText("TOTAL", startX + 5, startY + 25);
        ctx.fillText(`${formatCurrency(total)}`, startX + tableWidth - 100, startY + 25);

        if (onRenderComplete) {
          onRenderComplete();
        }
      } catch (error) {
        console.error("Erro ao gerar a imagem do certificado:", error);
      }
    };
    generateCertificateImage();
  }, [member, payments, total, onRenderComplete]);

  return <canvas ref={canvasRef} style={{ display: "none" }} />;
});

const formatCurrency = (value) => {
  return Number(value).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export default PaymentReceipt;
